@use '../../../assets/styles/utilities.scss';

:host {
  display: block;
}

.gradient-bar {
  width: 92px;
  height: 3px;
  border-radius: 1px;
  background: var(--header-menu-highlight, linear-gradient(90deg, rgba(0, 0, 0, 0) 0%, #659ccf 50%, rgba(0, 0, 0, 0) 100%));
  bottom: -12px;
}

.animate-in {
  opacity: 0;
  animation: shotIn 0.3s cubic-bezier(0.4, 0, 0.2, 1) forwards;
}
@keyframes shotIn {
  to {
    opacity: 1;
  }
}
